module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOpJREFUeNpiZMACtJa/Pw+kDID4wrVIQUMgPwHIng+VDgSKbUDXw4TFEAWoIQxIdDySknpsljMBNTYA8X8obgDa9gCLug9IbAOoZRguqidkGxBsROPnE/QaEjgAYwBduQDNVQGkGHQQjY8cwApA7zkQZRDQFQ1oQgvR+PEYBgE1MYIwHteB1IC8+gCX9/B5DRtA9p4ANH2RZdBENL4/WQZB09gFZO8BXSVAjouwBXoCuQYtwBZ7TND8Bc4iRHrvA1qgg7MMThcRMBgjy5DjNaxZhiyDsGUZkEGNSAIw9gU0GhtoRHLVAoAAAwD7NVAh8J91WgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/icon/kuozhanon.png
// module id = eKd+
// module chunks = 1